import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { openModal } from 'modal/index';
import Button from 'base/components/Button';
import { DeleteIcon, FileDownloadIcon, EmailIcon, WifiOffIcon } from 'base/components/Icon';
import Flex from 'base/components/Flex';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { downloadMultipleDocumentsAndFolders } from '../../store/documents/actions';
import { setSelectedData } from '../../store/fileexplorer/actions';
import { getSelectedDocuments, getSelectedFolders } from '../../store/fileexplorer/selectors';

export default function FileExplorerBulkActions({ selectedData }) {
  const dispatch = useAppDispatch();
  const selectedDocuments = useAppSelector(getSelectedDocuments);
  const selectedFolders = useAppSelector(getSelectedFolders);

  useEffect(() => {
    dispatch(setSelectedData(selectedData));
  }, [selectedData, dispatch]);

  const handleBulkDelete = useCallback(() => dispatch(openModal('FILE_EXPLORER_BULK_DELETE')), [dispatch]);

  const handleBulkShare = useCallback(() => dispatch(openModal('DOCUMENT_SHARE')), [dispatch]);

  const handleBulkDownload = useCallback(() => {
    dispatch(downloadMultipleDocumentsAndFolders(selectedDocuments, selectedFolders));
  }, [dispatch, selectedDocuments, selectedFolders]);

  const handleBulkCacheOffline = useCallback(() => {
    dispatch(openModal('DOCUMENT_CACHE_OFFLINE'));
  }, [dispatch]);

  const hasSomePermission = useCallback(
    (entities, permission) => entities.some(entity => entity.permissions && entity.permissions[permission]),
    [],
  );

  const canShare = hasSomePermission(selectedData, 'canShare');
  const canDelete = hasSomePermission(selectedData, 'canDelete');
  return (
    <Flex>
      <Button onClick={handleBulkDownload}>
        <FileDownloadIcon /> Download
      </Button>
      {canDelete && (
        <Button onClick={handleBulkDelete}>
          <DeleteIcon /> Delete
        </Button>
      )}
      {canShare && (
        <Button onClick={handleBulkShare}>
          <EmailIcon /> Share
        </Button>
      )}
      <Button onClick={handleBulkCacheOffline}>
        <WifiOffIcon /> Save offline
      </Button>
    </Flex>
  );
}
FileExplorerBulkActions.propTypes = {
  selectedData: PropTypes.arrayOf(PropTypes.any).isRequired,
};
